

























import { BButton, BSpinner, VBTooltip } from "bootstrap-vue";
import { TemplateInterface } from "@/interfaces/template.interface";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    components: { BButton, BSpinner },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        isLoading: {
            required: false,
            type: Boolean,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        submittable: {
            required: false,
            type: Boolean,
        },
        template: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
});
